<template>
    <v-list-group v-if="node.children && node.children.length" no-action :value="node.id">
        <template #activator="{ props: activatorProps }">
            <v-list-item
                v-bind="activatorProps"
                :title="node.menuTitle"
                :active="isActive"
                active-class="v-list-item--active"
                class="v-list-item--link"
                link
                role="button"
            >
                <template v-if="node.icon" #prepend>
                    <v-badge v-if="node.badge" :content="node.badge" color="primary" location="top end">
                        <v-icon :icon="node.icon"></v-icon>
                    </v-badge>
                    <v-icon v-else :icon="node.icon"></v-icon>
                </template>
            </v-list-item>
        </template>

        <template v-if="showChildren">
            <MenuNode v-for="child in node.children" :key="child.id" :node="child" :show-children="showChildren" />
        </template>
    </v-list-group>

    <v-list-item v-else :to="node.to" :title="node.menuTitle">
        <template v-if="node.icon" #prepend>
            <v-badge v-if="node.badge" :content="node.badge" color="primary" location="top end">
                <v-icon :icon="node.icon"></v-icon>
            </v-badge>
            <v-icon v-else :icon="node.icon"></v-icon>
        </template>
    </v-list-item>
</template>

<script setup>
/*
    Organization / ordering applied:
    1. Imports
    2. Props / Emits
    3. Constants
    4. Stores & top-level services
    5. Reactive state (refs/reactive)
    6. Validation rules & setup
    7. Computed
    8. Handlers / methods
    9. Helpers / lifecycle
*/

// 1. Imports
import { computed } from 'vue'
import { useRoute } from 'vue-router'

// 2. Props / Emits
const props = defineProps({
    node: {
        type: Object,
        required: true
    },
    showChildren: {
        type: Boolean
    }
})

// 3. Constants
// (none)

// 4. Stores & top-level services
const route = useRoute()

// 5. Reactive state (refs/reactive)
// (none)

// 6. Validation rules & setup
// (none)

// 7. Computed
const isActive = computed(() => {
    const id = props.node?.id
    if (!id) return false

    const matchedIds = (route.matched || []).map((m) => m.name || m.path).filter(Boolean)
    return matchedIds.includes(id)
})

// 8. Handlers / methods
// (none)

// 9. Helpers / lifecycle
// (none)
</script>
